import React, { useContext } from 'react';
import styled from 'styled-components';
import { Card } from './ProgramListingCard';
import { ProgramCategory } from '@gql/generated';
import LanguageContext from '@lib/contexts/languageContext';
import useFlags from '@lib/hooks/useFlags';
import { Anchor } from './OfferCard';

const Body = styled.div<{ appearance?: ProgramCategory }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  text-align: center;
  /* padding: 15% 10px; */
`;

const Image = styled.img`
  width: 100%;
  min-height: 100%;
  object-fit: cover;
`;

export const YearlyOfferCard = ({ className = '' }) => {
  const [flags] = useFlags();
  const lang = useContext(LanguageContext);

  if (!flags.yearly_campaign_banners) {
    return null;
  }

  const img = ['en', 'fi'].includes(lang)
    ? '/static/yearly/EN_Banner_Startpage_Square_b.jpg'
    : '/static/yearly/SE_Banner_Startpage_Square_b.jpg';

  return (
    <Anchor href={`/${lang}/yearly`} className={className}>
      <Card data-testid="OfferCard">
        <Body>
          <Image src={img} />
        </Body>
      </Card>
    </Anchor>
  );
};
